export enum TicketingChartDataTypeCode{
    TicketsSold = 0,
    Revenue = 1
}